import { generateResponsiveCSS } from "@/(admin)/modules/ui-builder/config/lib/helper"
import { convertVideoLink } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/Video/utils/utils"
import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"

export type VideoProps = {
  linkVideo?: string
  borderRadius?: string
  heightMobile?: string
  heightDesktop?: string
  className?: string
}

export const RenderConfig: ComponentConfig<VideoProps> = {
  render: ({
    linkVideo,
    heightMobile,
    heightDesktop,
    borderRadius,
    className,
  }) => {
    const id = `video-${Math.random().toString(36).substr(2, 9)}`


    const styles = {
      mobile: {
        height: heightMobile,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        borderRadius,
      },
      tablet: {
        height: heightMobile,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        borderRadius,
      },
      desktop: {
        height: heightDesktop,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        borderRadius,
      },
    }

    const embedUrl = convertVideoLink(linkVideo)

    return (
      <>
        {generateResponsiveCSS(id, styles || {})}
        <div id={id} className={`${id} ${twMerge(className)}`}>
          <div className="relative overflow-hidden w-full h-full cursor-pointer group"
            style={{ borderRadius: borderRadius }}
          >
            {embedUrl ? (
              <iframe
                className=" w-full h-full"
                src={embedUrl}
                title="Video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            ) : (
              <div className="w-full h-full flex items-center justify-center bg-gray-100 text-gray-500">
                Please provide a valid video link
              </div>
            )}
          </div>
        </div>
      </>
    )
  },
}
